import { priceActions } from '../../services';

export const priceReducer = ( state = { type: 'listPrice' }, action ) => {
  const newState = { ...state };
  
  switch ( action.type ) {
    case priceActions.LOADING:
      const lineItems = Array.isArray( action.lineItems ) ? action.lineItems : [action.lineItems];

      for( let item of lineItems ) {
        newState[item.materialName] = { loading: true };
      }

      return newState;
    case priceActions.FAILED:
      for( let lineItem of action.lineItems ) {
        newState[lineItem?.materialName].loading = false;
      }
      return newState;
    case priceActions.RETRIEVED:
      const priceItems = Array.isArray( action.result ) ? action.result : [action.result];

      for( let item of priceItems ) {
        newState[item.material] = item;
      }

      return newState;
    case priceActions.CHANGEPRICETYPE:
      return { ...state, type: action.priceType };
    default:
      return state;
  }
};